module.exports = __webpack_public_path__ + "img/dp-gr-xx1.64cca19b.png";